/**
 * Tag service for workspace-scoped tag CRUD operations.
 */
import type { TagColor } from '@hofsync/design-system';
import api from './api';

export interface TagDefinition {
    id: string;
    name: string;
    color: TagColor;
    created_at: string;
    updated_at: string;
}

interface ListTagsResponse {
    tags: TagDefinition[];
}

interface TagResponse {
    tag: TagDefinition;
}

export const tagService = {
    listTags: async (): Promise<TagDefinition[]> => {
        const response = await api.get<ListTagsResponse>('/user-documents/tags');
        return response.data.tags;
    },

    createTag: async (name: string, color: string): Promise<TagDefinition> => {
        const response = await api.post<TagResponse>('/user-documents/tags', { name, color });
        return response.data.tag;
    },

    updateTag: async (tagId: string, name: string, color: string): Promise<TagDefinition> => {
        const response = await api.put<TagResponse>(`/user-documents/tags/${tagId}`, { name, color });
        return response.data.tag;
    },

    deleteTag: async (tagId: string): Promise<void> => {
        await api.delete(`/user-documents/tags/${tagId}`);
    },

    /** Update the tags assigned to a document */
    updateDocumentTags: async (docId: string, tagIds: string[]): Promise<void> => {
        await api.put(`/user-documents/${docId}/tags`, { tags: tagIds });
    },
};
